import { render, staticRenderFns } from "./PageFitness.vue?vue&type=template&id=7aaf440e"
import script from "./PageFitness.vue?vue&type=script&lang=js"
export * from "./PageFitness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports